import React from 'react'

export function Connector({ active }: { active: boolean }) {
  return (
    <div
      className="flex-1 h-px mx-3 transition-all duration-500"
      style={{ background: active ? '#111827' : '#d1d5db' }}
    />
  )
}